export type ScoreVisualTone = 'success' | 'brand' | 'warning' | 'danger';

export function scoreVisualTone(score: number): ScoreVisualTone {
  if (score >= 80) return 'success';
  if (score >= 65) return 'brand';
  if (score >= 50) return 'warning';
  return 'danger';
}
